module.exports = __webpack_public_path__ + "assets/img/logo-sm.dd8f962a.png";